module.exports = __webpack_public_path__ + "img/front length from hps to hem.713641c5.png";